module.exports = __webpack_public_path__ + "media/banners/ubezpieczenia-menu-b30ac3f3.svg";